<template>
    <div style="width: 100%;overflow: hidden;height: 100%" id="message">
        <div
                style="margin-top: 25px;height: calc( 100% - 50px );float: left;width: 400px;background:#f5f4f5;margin-left: 40px;
        border: 1px solid #eeeeee;box-sizing: border-box" >
            <ul class="messageList_ul" v-if="messageList.length > 0" style="height: 100%;overflow: auto;">
                <li :class="i===index ? 'isActive' : 'isInActive' " v-for="(item,i) in messageList" :key="i"
                        style="width: calc(100% - 12px) ;height: 60px;padding: 10px 5px 15px"
                    @click="onTabClick(i,item)">
                    <div style="float: left;height: 60px;width: 70px;text-align: center;">
                        <img :src="item.icon" style="margin-top: 10px;object-fit: cover"
                             width="50"
                             alt="">
                    </div>
                    <div style="float: left;font-size: 12px;color: white;width:270px;height:60px;display: flex;justify-content: space-between;flex-direction: column">
                        <p style="font-size: 15px;margin: 5px 0 5px 10px;color: black;
                        font-weight: 500;line-height: 17px">{{item.title}}</p>
                        <span style="color: #9FA5AC;margin-left: 10px;width: 250px;line-height: 14px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.subtitle}}</span>

                    </div>
                    <div style="float: right;height: 60px;margin-right: 10px">
                        <div
                                style="width: 20px;height: 20px;border-radius: 50%;margin-top: 20px;
                                background: #87909A;color: white;;text-align: center;line-height: 20px">
                                {{item.unread_count}}
                        </div>
                    </div>
                </li>
            </ul>
            <div v-if="messageList.length === 0" style="text-align: center;width: 100%;height: 100%">
                  <span style="line-height: 300px;color: #bbbbbb">
                暂无数据
            </span>
            </div>
        </div>
<!--        <div style="width: calc(100% - 482px);border-left:none;-->
<!--        height: calc(100% - 60px) ;float: left;margin-top: 40px"-->
<!--             v-if="index === 0">-->
<!--            <ul style="width: 100%;height: 100%;border: 1px solid #eeeeee;box-sizing: border-box;padding:10px 0px 10px 10px">-->
<!--                <li v-for="(item,i) in listInfoArray" style="height:80px;margin-top:10px">-->
<!--                    <div style="float: left;min-width: 20px;width: 5%;height: 100%;text-align: center;overflow: hidden">-->
<!--                        <img v-if="item.icon" :src="item.icon" style="margin-top: 20px;width: 15px" alt="">-->
<!--                    </div>-->
<!--                    <div style="float: left;border-bottom: 1px solid #eeeeee;width: 95%;padding: 10px 0;-->
<!--                    position: relative;height: 55px">-->
<!--                        <p v-text="'[' + item.category + ']' + ' ' + item.month + ' ' +item.lastName"-->
<!--                           style="margin: 10px 0;font-size: 14px"></p>-->

<!--                        <div style="position: absolute;right: 10px;top: 0;height: 100%">-->
<!--                            <p style="font-size: 12px;margin-top: 20px;margin-bottom: 5px;color: #9B9B9B">-->
<!--                                {{item.time}}</p>-->
<!--                            <el-button size="mini" style="background:#FF9901;color: white;border: none ">详情</el-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
<!--        <div style="width: calc(100% - 482px);border-left:none;-->
<!--        height: calc(100% - 60px) ;float: left;margin-top: 40px"-->
<!--             v-if="index === 1">-->
<!--            <ul style="width: 100%;height: 100%;border: 1px solid #eeeeee;box-sizing: border-box;padding:10px 0px 10px 10px">-->
<!--                <li v-for="(item,i) in listInfoArray" style="height:80px;margin-top:10px">-->
<!--                    <div style="float: left;min-width: 20px;width: 5%;height: 100%;text-align: center;overflow: hidden">-->
<!--                        <img v-if="item.icon" :src="item.icon" style="margin-top: 20px;width: 15px" alt="">-->
<!--                    </div>-->
<!--                    <div style="float: left;border-bottom: 1px solid #eeeeee;width: 95%;padding: 10px 0;-->
<!--                    position: relative;height: 55px">-->
<!--                        <p v-text="'[' + item.category + ']' + ' ' + item.lastName"-->
<!--                           style="margin: 10px 0;font-size: 14px"></p>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.comments"></span>-->
<!--                        <div style="position: absolute;right: 10px;top: 0;height: 100%">-->
<!--                            <p style="font-size: 12px;margin-top: 20px;margin-bottom: 5px;color: #9B9B9B">-->
<!--                                {{item.time}}</p>-->
<!--                            <el-button size="mini" style="background:#FF9901;color: white;border: none ">详情</el-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
<!--        <div style="width: calc(100% - 482px);border-left:none;-->
<!--        height: calc(100% - 60px) ;float: left;margin-top: 40px"-->
<!--             v-if="index === 2">-->
<!--            <ul style="width: 100%;height: 100%;border: 1px solid #eeeeee;box-sizing: border-box;padding:10px 0px 10px 10px">-->
<!--                <li v-for="(item,i) in listInfoArray" style="height:80px;margin-top:10px">-->
<!--                    <div style="float: left;min-width: 20px;width: 5%;height: 100%;text-align: center;overflow: hidden">-->
<!--                        <img v-if="item.icon" :src="item.icon" style="margin-top: 20px;width: 15px" alt="">-->
<!--                    </div>-->
<!--                    <div style="float: left;border-bottom: 1px solid #eeeeee;width: 95%;padding: 10px 0;-->
<!--                    position: relative;height: 55px">-->
<!--                        <p v-text="item.text" style="margin: 10px 0;font-size: 14px"></p>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.month"></span>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.type"></span>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.comments"></span>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="'[' + item.listInfo.location">-->

<!--                        </span>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.listInfo.address + ']'"></span>-->

<!--                        <div style="position: absolute;right: 10px;top: 0;height: 100%">-->
<!--                            <p style="font-size: 12px;margin-top: 20px;margin-bottom: 5px;color: #9B9B9B">-->
<!--                                {{item.time}}</p>-->
<!--                            <el-button size="mini" style="background:#FF9901;color: white;border: none ">详情</el-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
<!--        <div style="width: calc(100% - 482px);border-left:none;-->
<!--        height: calc(100% - 60px) ;float: left;margin-top: 40px"-->
<!--             v-if="index === 3">-->
<!--            <ul style="width: 100%;height: 100%;border: 1px solid #eeeeee;box-sizing: border-box;padding:10px 0px 10px 10px">-->
<!--                <li v-for="(item,i) in listInfoArray" style="height:80px;margin-top:10px">-->
<!--                    <div style="float: left;min-width: 20px;width: 5%;height: 100%;text-align: center;overflow: hidden">-->
<!--                        <img v-if="item.icon" :src="item.icon" style="margin-top: 20px;width: 15px" alt="">-->
<!--                    </div>-->
<!--                    <div style="float: left;border-bottom: 1px solid #eeeeee;width: 95%;padding: 10px 0;-->
<!--                    position: relative;height: 55px">-->
<!--                        <p v-text="'[' + item.category + ']' + ' ' +item.month + ' ' + item.lastName"-->
<!--                           style="margin: 10px 0;font-size: 14px"></p>-->
<!--                        <span style="font-size: 12px;color: #9B9B9B;" v-text="item.comments"></span>-->
<!--                        <div style="position: absolute;right: 10px;top: 0;height: 100%">-->
<!--                            <p style="font-size: 12px;margin-top: 20px;margin-bottom: 5px;color: #9B9B9B">-->
<!--                                {{item.time}}</p>-->
<!--                            <el-button size="mini" style="background:#FF9901;color: white;border: none ">详情</el-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->
        <div style="width: calc(100% - 482px);border-left:none;height: calc(100% - 50px) ;float: left;margin-top: 25px" id="div3">
            <ul style="width: 100%;height: 100%;border: 1px solid #eeeeee;box-sizing: border-box;
            padding:0px 0px 0px 10px;border-left: none;overflow: auto">
                <li v-for="(item,i) in listInfoArray" style="height:70px;">
                    <div style="float: left;min-width: 20px;width: 5%;height: 70px;text-align: center;overflow: hidden">
                        <img v-if="item.icon" :src="item.icon" style="margin-top: 25px;width: 15px" alt="">
                    </div>
                    <div style="float: left;border-bottom: 1px solid #eeeeee;width: 95%;padding: 5px 0 10px;
                    position: relative;height: 55px">
                        <p v-text="item.title"
                           style="margin: 10px 0;font-size: 14px"></p>
                        <span style="font-size: 12px;color: #9B9B9B;width: 400px;display: block; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" v-text="item.subtitle"></span>
                        <div style="position: absolute;right: 10px;top: -7px;height: 100%;text-align: center;width: 100px;">
                            <p style="font-size: 12px;margin-top: 20px;margin-bottom: 5px;color: #9B9B9B">
                                {{item.time}}</p>
                            <el-button size="mini" @click.native="onListInfo(item)"
                                       style="background:#FF9901;color: white;border: none ">详情</el-button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div id="div4Action" style="width: calc(100% - 482px);height: calc(100% - 50px) ;margin-left: 400px;">
            <img src="../../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" style="margin:0 auto;display: block;" alt="">
        </div>
        <el-dialog
                :visible.sync="dialogVisit"
                width="70%"
                :show-close="false"
                style="vertical-align: center;color: #FFF9F3;">
            <div style="height: 800px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 15px;">
                    <el-col :span="6">
                        <div style="color: #3998F7;font-size: 20px;">公司通知
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <div align="right">
                            <p style="margin: 0;display: inline-block;color:#999999;margin-right: 40px;">最后发送日期：{{date}}</p>

                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="back" style="margin-top: 20px;">
                    <el-form ref="formList" :model="companyNoticeList" label-width="10%" hide-required-asterisk>
                        <el-row style="margin: 0 auto;width: 95%">
                            <el-col>
                                <el-form-item label="标题" >
                                    <el-input v-model="companyNoticeList.title" placeholder="请输入标题" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="内容">
                                    <!--                                    <quill-editor ref="editer"  v-model="companyNoticeList.content" style="height:250px;" class="myQuillEditor"-->
                                    <!--                                                  :options="editorOption"-->

                                    <!--                                                  />-->
<!--                                    <Editorbar v-model="companyNoticeList.content" :isClear="isClear" @change="changeEditor1"></Editorbar>-->
                                    <div>
                                        <div id="toolbar" slot="toolbar" style="height: 0;padding:0;border:none;">
<!--                                            <button class="ql-bold" title="加粗">Bold</button>-->
<!--                                            <button style="width: auto">-->
<!--                                                <select class="ql-header" title="段落格式">-->
<!--                                                    <option selected>正文</option>-->
<!--                                                    <option value="2">标题1</option>-->
<!--                                                    <option value="3">标题2</option>-->
<!--                                                    <option value="4">标题3</option>-->
<!--                                                </select>-->
<!--                                            </button>-->

<!--                                            <button class="ql-list" value="ordered" title="有序列表"></button>-->
<!--                                            <button class="ql-list" value="bullet" title="无序列表"></button>-->
<!--                                            <button style="width: auto"><select class="ql-color" value="color" title="字体颜色"></select></button>-->


<!--                                            <button class="icon-pic custom-icon " title="图片" style="font-size: 18px" >-->
<!--                                                <i class="el-icon-picture-outline" style="color: #444444"></i>-->
<!--                                            </button>  &lt;!&ndash; 插入图片 &ndash;&gt;-->
<!--                                            <button class="icon-video custom-icon " title="视频" style="font-size: 18px" >-->
<!--                                                <i class="el-icon-film" style="color: #444444"></i>-->
<!--                                            </button>  &lt;!&ndash; 插入视频 &ndash;&gt;-->
                                        </div>

                                    </div>


                                    <quill-editor
                                            v-model="companyNoticeList.content"
                                            ref="myQuillEditor"
                                            :options="editorOption"
                                            disabled
                                           >
                                    </quill-editor>

                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </div>

        </el-dialog>

    </div>



</template>

<script>
    import http from '../../../APIService/http'
    import tutoring_task from '../../../assets/images/tutoring_task.png'
    import meeting_task from '../../../assets/images/meeting_task.png'
    import weekplan_task from '../../../assets/images/weekplan_task.png'
    import travel_icon from '../../../assets/images/travel_icon.png'
    import company_task from '../../../assets/images/company_task.png'
    import redPoint from '../../../assets/images/redPoint.png'
    import travel_task from '../../../assets/images/travel_task.png'
    import internal_icon from '../../../assets/images/internal_icon.png'
    import leave_msg_task from '../../../assets/images/leave_msg_task.png'
    import leave_msg_notice from '../../../assets/images/leave_msg_notice.png'
    import moment from 'moment'
    import Editorbar from './editoritem'
    import { quillEditor } from 'vue-quill-editor'
    // import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    // import 'quill/dist/quill.bubble.css'
    import * as Quill from 'quill' //引入编辑器
    // import { ImageDrop } from 'quill-image-drop-module';
    // Quill.register('modules/imageDrop', ImageDrop);
    // import ImageResize from 'quill-image-resize-module'  //调整大小
    // Quill.register('modules/imageResize', ImageResize)  //添加
    import Video from './video.js'
    Quill.register(Video, true);



    export default {
        name: "messageList",
        data(){
            return {
                index:this.GLOBAL.task_index,
                dialogVisit:false,
                messageList:[],
                listInfoArray:[],
                listInfo:{},
                searchForm:{},
                date:'',
                companyNoticeList:{
                    title:'',
                    content:'',
                },
                collectionList:[],
                editor: null,   // 富文本编辑器对象

                editorOption: { //  富文本编辑器配置
                    modules: {
                        toolbar: '#toolbar'
                    },
                    theme: 'snow',
                    placeholder: '请输入正文'
                },
                newArr:[],
                getImg_index:0,
                getImg:'',
                getVid_index:0,
                getVid:'',
            }
        },
        components:{
            // Editorbar
            quillEditor
        },
        methods:{

            changeEditor1 (res) {
                console.log(res)        // 这个res就是实时输入的富文本的内容，打印出来是实时输入的字符串html
            },
            close(){
                this.dialogVisit = false
            },
            onTabClick(i,item){
                this.index = i
                this.GLOBAL.task_index = i
                this.listInfoArray = []



                this.init(item.category)
            },
           async init(type){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id
                    }

                    if (type){
                        data.type = type
                    } else {
                        data.type = ''
                    }
                    await http.post('/wapi/msg_controller/getMessagesList',data).then(res=>{
                        if (res.success === true){
                            console.log(res.data,44)
                            //处理返回的数据
                            if (type){
                                this.being_list_Data(res.data)
                            } else {
                                this.listInfo = res.data[this.index]
                                this.beingData(res.data)
                                this.init(this.listInfo.category)
                            }
                        if(res.data.length>0){
                            var oDiv = document.getElementById("div3");
                            var oDiv4 = document.getElementById('div4Action')

                                oDiv.style.display = "block";
                                oDiv4.style.display='none'

                        }

                            loading.close()
                        }else {
                            loading.close()
                        }

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            beingData(data){
                for (let i=0;i<data.length;i++){
                    let item = data[i]

                    // item.text = ""
                    switch (item.category) {
                        case "辅导/协访" :
                            item.icon = tutoring_task
                            // let coaching_str = ' ' + item.month + ' ' +
                            //     moment(item.listInfo.start_time).format('HH:mm')
                            //     +
                            //     '-'
                            //     +
                            //     moment(item.listInfo.end_time).format('HH:mm')
                            // item.listInfo.confirmed_resultText = ''
                            // if (item.listInfo.submitted_date === ''){
                            //     item.text = '[计划未提交]'
                            // }
                            //
                            // if (!(item.listInfo.submitted_date === '') && item.listInfo.confirmed_date === ''){
                            //     item.text = '[计划待确认]'
                            // }
                            //
                            // if (!(item.listInfo.confirmed_date === '') && item.listInfo.confirmed_result === 'APPROVED') {
                            //     item.text = '[计划已确认]'
                            // }
                            //
                            // if (!(item.listInfo.confirmed_date === '') && item.listInfo.confirmed_result === "DENIED"){
                            //     item.text = '[计划被拒绝]'
                            // }
                            // if (item.listInfo.completed === 'T' ){
                            //     item.text = '[协访已完成]'
                            // }
                            // if (item.listInfo.confirmed_resultText === ''){
                            //     item.text = '[计划进行中]'
                            // }
                            // item.text = item.text + coaching_str
                            break;
                        case "差旅计划" :
                            // item.text = item.month
                            item.icon = travel_icon
                            break;
                        case "周计划" :
                            item.icon = weekplan_task
                            // if (item.listInfo.contents) {
                            //     if (item.listInfo.contents.comments) {
                            //         item.text = '[留言]' + ' ' + item.listInfo.contents.comments
                            //     }else {
                            //         item.text = item.comments
                            //     }
                            // }else {
                            //     item.text = item.comments
                            // }
                            break;
                        case "内部事务" :
                            // item.text = item.month
                            item.icon = internal_icon
                            break;
                        case "会议/活动" :
                            item.icon =  meeting_task
                            // let str = ' '+item.month + ' ' + item.type
                            // if (item.status === 'SUBMITTED'){
                            //     item.text = '[待审核]'
                            // }
                            // if (item.status === 'APPROVED'){
                            //     item.text = '[已批准]'
                            // }
                            // if (item.status === 'DENIED'){
                            //     item.text = '[已拒绝]'
                            // }
                            // if (item.status === 'ACTIVE' || item.status === 'DRAFT'){
                            //     item.text = '[未提交]'
                            // }
                            // if (item.completed === 'T'){
                            //     item.text = '[已完成]'
                            // }
                            // item.text = item.text + str
                            break;
                        case "请假/休假" :
                            // item.text = item.month
                            item.icon = leave_msg_task
                            break;
                        case "公司通知" :
                        // item.text = item.month
                        item.icon = leave_msg_notice
                        break;
                    }
                }

                this.messageList = JSON.parse(JSON.stringify(data));

                console.log(this.messageList,11)
            },
            onListInfo(row){
                try {
                    let user = this.$store.getters.getUser
                    let data = row
                    data.type = 'mark'
                    data.tenant_id = user.tenant_id
                    data.user_id = user.user_id
                    data.isAll = 'F'
                    http.post('/wapi/msg_controller/deleteNotification', data).then(res=>{
                            this.oNroutingHop(row)
                    })
                }catch (e) {

                }
            },
            oNroutingHop(row){
                console.log(row)
                if(row.lastName){
                    row.listInfo.titleName = row.lastName
                }

                this.searchForm = row.listInfo
                if (row.category_type === "MEETING") {

                    this.$router.push({name:'meetInfo',params:row.listInfo})

                }else if (row.category_type === "TRAVEL") {

                    this.$router.push({name:'travel',params:row.listInfo})

                }else if (row.category_type === "HCP_CALL"){

                    this.$router.push({name:'dropDetails',params:row.listInfo})

                }else if (row.category_type === "TRAINING_MEETING") {

                    this.$router.push({name:'train',params:row.listInfo})

                }else if (row.category_type === "COACHING") {

                    this.$router.push({name:'assist',params:row.listInfo})

                }else if (row.category_type === "DISTRIBUTOR") {

                    this.$router.push({name:'businessDetails',params:row.listInfo})

                }else if (row.category_type === "LEAVE_TYPE") {

                    this.$router.push({name:'holiday',params:row.listInfo})

                }else if (row.category_type === "PLAN") {

                    this.$router.push({name:'WeekplanInfo',params:row.listInfo})

                }else if (row.category_type === "PAPERWORK") {
                    this.$router.push({name:'syndicate',params:row.listInfo})
                }else if (row.category_type === "NOTICES") {
                    console.log(row)

                    this.companyNoticeList={
                        title:row.listInfo.title,
                        content:'',
                    }
                    this.collectionList=[]

                    this.getNextUrl(-1,this.collectionList,row.listInfo.contents);

                    this.date = moment(row.listInfo.sent_date).format('YYYY年MM月DD日 HH:mm')
                }
            },
            getNextUrl(index, arrayList,contents) {


                var start_index;
                if(index == -1){
                    start_index=contents.indexOf("|&");
                }else {
                    start_index = index;
                }
                var end_index=contents.indexOf("|&", start_index+1);
                var result=contents.substring(start_index+2,end_index);

                var obj={
                    file_type:'',
                    file_id:'',
                    url:''
                }


                if(result.indexOf("picture_id") !== -1){
                    obj.file_type="picture_id";
                    obj.file_id=JSON.parse(result).picture_id;
                }
                if(result.indexOf("video_id") !== -1){
                    obj.file_type="video_id";
                    obj.file_id=JSON.parse(result).video_id;
                }




                let url = ''

                let Body = new FormData()
                Body.append('credential', '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4')
                Body.append('file_ids', obj.file_id)
                Body.append('tenant_id', this.$store.getters.getUser.tenant_id)
                Body.append('reference_obj', 'CLIENT')
                Body.append('reference_id', 'com.saasyun.android')


                let config = {
                    headers:{'Content-Type':'multipart/form-data'}
                };


                http.post('/files/downloadfiles',Body,config).then(response => {


                    if (response.success) {

                        if(response.data.length>0){
                            url = response.data[0].url


                            if(obj.file_type == 'picture_id'){
                                obj.url = '<img src='+url+' alt="picvision" style="margin-top:10px;max-width:100%;">'

                            }else if(obj.file_type == 'video_id'){
                                obj.url = '<video controls="controls" poster="" src='+url+' height="300" style="margin-top:10px;max-width:100%;">'

                            }
                            arrayList.push(obj);
                            if(contents.indexOf("|&",end_index+1) != -1){
                                var ind=contents.indexOf("|&", end_index+1);
                                this.getNextUrl(ind,arrayList,contents);
                            }else{

                                this.replaceUrl(arrayList,contents)


                            }
                        }else{
                            this.companyNoticeList.content=contents
                            this.dialogVisit = true
                        }




                    }
                })


                // this.getLabel(obj,contents)



            },
            replaceUrl(arr,contents){

                let str = ''
                for(let i =0;i<arr.length;i++){
                    if(arr[i].file_type == 'picture_id'){
                        var oldStr = "|&{"+"\"picture_id\""+":\""+arr[i].file_id+"\"}|&";
                        var newStr = arr[i].url
                        str = contents.replace(oldStr,newStr)
                        contents = str
                    }else if(arr[i].file_type == 'video_id'){
                        var oldStr = "|&{"+"\"video_id\""+":\""+arr[i].file_id+"\"}|&";
                        var newStr = arr[i].url
                        str = contents.replace(oldStr,newStr)
                        contents = str
                    }
                }
                this.companyNoticeList.content=str
                this.dialogVisit = true
            },
            being_list_Data(data){

                for (let i=0;i<data.length;i++){
                    let obj = data[i]
                    if (obj.unread === 'T'){
                        obj.icon = ''
                    } else {
                        obj.icon = redPoint
                    }
                    obj.text = ''
                    obj.instructionsText = ''
                    // if (obj.category_type === 'MEETING'){
                    //     if (obj.status === 'SUBMITTED'){
                    //         obj.text =  '主管待审核'
                    //     }
                    //     if (obj.status === 'APPROVED'){
                    //         obj.text = '主管已审批通过'
                    //     }
                    //     if (obj.status === 'DENIED'){
                    //         obj.text = '主管已拒绝'
                    //     }
                    //     if (obj.status === 'ACTIVE' || obj.status === 'DRAFT'){
                    //         obj.text = '未提交'
                    //     }
                    //     if (obj.completed === 'T'){
                    //         obj.text = '已完成'
                    //     }
                    //
                    //
                    //     obj.instructionsText = obj.month + ' ' + obj.type + ' ' + obj.comments + ' ' + ' [' +
                    //         obj.listInfo.location
                    //         +obj.listInfo.address + ']'
                    // }else if (obj.category_type === 'COACHING') {
                    //     obj.instructionsText = obj.comments
                    //     obj.text = '[' + obj.category + ']' + ' ' + obj.month + ' ' +obj.lastName
                    //
                    // }else if (obj.category_type === 'PLAN') {
                    //     obj.instructionsText = obj.comments
                    //     obj.text = '[' + obj.category + ']' + ' ' + obj.lastName
                    // }else if (obj.category_type === 'TRAINING_MEETING') {
                    //     obj.instructionsText = obj.comments
                    //     obj.text =  '[' + obj.category + ']' + ' ' +obj.month + ' ' + obj.lastName
                    // }else if (obj.category_type === 'PAPERWORK') {
                    //     obj.instructionsText = obj.comments
                    //     obj.text =  '[' + obj.category + ']' + ' ' +obj.month + ' ' + obj.lastName
                    // }else if (obj.category_type === 'LEAVE_TYPE') {
                    //     obj.instructionsText = obj.comments
                    //     obj.text = '[' + obj.category + ']' + ' ' +obj.month + ' ' + obj.lastName
                    // }else if (obj.category_type === 'TRAVEL') {
                    //     var weekOfday = moment(obj.month,'YYYY年MM月DD').format('E')
                    //     let week = this.onWeekDate(weekOfday)
                    //     obj.instructionsText = obj.comments
                    //     obj.text = '[' + obj.category + ']' + ' ' +obj.month + ' （' + week + '） ' + obj.lastName
                    // }

                }

                this.listInfoArray = JSON.parse(JSON.stringify(data));
            },
            onWeekDate(i){
                switch (i) {
                    case "1" :
                        return '周一';
                    case "2":
                        return '周二';
                    case "3":
                        return '周三';
                    case "4":
                        return '周四';
                    case "5":
                        return '周五';
                    case "6":
                        return '周六';
                    case "7":
                        return '周日';
                }
            }
        },
        beforeRouteLeave(to, from, next){
            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if ((to.name === 'WeekplanInfo' ||
                to.name === 'holiday' ||
                to.name === 'businessDetails' ||
                to.name === 'meetInfo' ||
                to.name === 'assist' ||
                to.name === 'train' ||
                to.name === 'syndicate' ||
                to.name === 'dropDetails' ||
                to.name === 'travel') &&
                to.params.type !== 'new') {
                // console.log(this.searchForm)
                let condition = JSON.stringify(this.searchForm)
                localStorage.setItem('condition', condition)
            }else{
                localStorage.removeItem('condition')
                this.GLOBAL.task_index = 0
            }
            next()
        },
        created() {
            this.init()
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .messageList_ul li:hover{
        cursor: pointer;
    }
    .messageList_ul .isActive{
        background: rgba(74,144,266,0.1);
        border: 1px solid rgba(74,144,266,0.3);

    }

    .messageList_ul .isInActive{
        border: 1px solid transparent;

    }
    .messageList_ul li{
        transition: .2s;
    }
    #div3{
        display: none;
        margin-left: 15px;
    }
    #div4Action{
        margin-top: 200px;
    }
    #message >>>.el-form-item__label{
        font-weight: bold;
    }
    #message >>> .el-dialog__header{
        padding: 0;
    }
    #message >>> .ql-editor{
        height: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/task/components/messageList.vue